import "./polyfill";
import $ from "jquery";
import "picturefill";

// needed to set the path for Images used in JS files.
// import was required to set the value before the other imports.
import "./assetsDirectory.js";

import { ViewAllExpand } from "./ViewAllExpand";
import { DynamicBanner } from "./DynamicBanner";
import { DynamicPassword } from "./forms/DynamicPassword";
import { ProfileControl } from "./ProfileControl";
import { InterestsGroups } from "./forms/InterestsGroups";
import { PrivacyModal } from "./PrivacyModal";

import Forms from "./forms/forms.js";
import richText from "./richText.js";
import makeClickable from "./makeClickable.js";
import initSlideShow from "./components/SlideShow/initSlideShow.js";
// import initLogoCarousel from "./components/LogoCarousel/initLogoCarousel.js";
import initHeroSlideshow from "./components/HeroSlideshow/initHeroSlideshow.js";
import languageSelector from "./components/LanguageSelector/initLanguageSelector.js";
import VUAuthenticatedMenu from "./components/GlobalHeader/initVUAuthenticatedMenu.js";
import initBackgroundVideo from "./components/BackgroundVideo/initBackgroundVideo";
import initContentList from "./components/ContentList/initContentList.js";
import initTermsOfUse from "./components/TermsOfUse/initTermsOfUse";
import initTopicList from "./components/TopicListing/initTopicList";
import initTableOfContents from "./components/TopicListing/initTableOfContents";
import initSelectDropdown from "./components/Select/initSelectDropdown";
import initModal from "./components/Modal/initModal";
import initDownload from "./components/Download/initDownload";
import recentlyViewedTracking from "./components/RecentlyViewed/recentlyViewedTracking";
import readingPane from "./components/ReadingPane/readingPane.js";
import LocatorResultsOfficeSearchHandler from "./components/MapsTest/initMaps";
import initMailToForm from "./components/MigratedForms/initMailToForm.js";

import initGlobalHeader from "./components/GlobalHeader/initGlobalHeader.js";
import initSkipNavigation from "./components/SkipNavigation/initSkipNavigation.js";
import initBackToTop from "./components/BackToTop/initBackToTop.js";
import renderYouTubeVideo from "./components/YouTubeVideo/renderYouTubeVideo.jsx";
import initListItem from "./components/ListItem/initListItem.js";
import initAlertBanner from "./components/AlertBanner/initAlertBanner.js";
import { initAEMScriptBridge } from "./components/LegacyAEM";
import initFormValidation from "./initFormValidation.js";
import initMarketoForms from "./initMarketoForms.js";

// import initMobileLanguageDropdown from "./components/LanguageSelector/initMobileLanguageDropdown.js";
import initMobileLanguageDropdown from "./components/LanguageSelector/initMobileLanguageDropdown.js";

// React Apps
import { renderDynamicContentListing } from "./components/SearchModules/DynamicContentListing/renderDynamicContentListing.jsx";
import { renderPromoListing } from "./components/SearchModules/PromoListing/renderPromoListing.jsx";
import { renderSearch } from "./components/SearchModules/Search/renderSearch.jsx";
import { renderCalculators } from "./components/Calculators/renderCalculators.jsx";
import { renderFindOffice } from "./components/FindOffice/renderFindOffice.jsx";
import { renderAgencyVerifications } from "./components/AgencyVerification/renderAgencyVerification.jsx";
import initAccordion from "./components/Accordion/initAccordion.js";
import initTabs from "./components/Tabs/initTabs.js";
import { initBreadcrumb } from "./components/Breadcrumbs/initBreadcrumb.js";
import initUtilityNav from "./components/UtilityNav/initUtilityNav.js";
import initSearchBox from "./components/SearchBox/initSearchBox.js";
import { initRecentlyViewed } from "./components/RecentlyViewed/initRecentlyViewed.jsx";
import { initRecentlyViewedMobile } from "./components/RecentlyViewed/initRecentlyViewedMobile.jsx";
import { initFindOfficeViewToggle } from "./components/FindOffice/initFindOfficeViewToggle.js";
import { initRegistrationForm } from "./components/RegistrationForm/initRegistrationForm.jsx";
import { initMemberProfileForm } from "./components/MemberProfile/initMemberProfileForm.jsx";
import { initFindOfficePager } from "./components/FindOffice/initFindOfficePager.js";
import { initAutocomplete } from "./components/FormItems/autocomplete.js";
import { initFindOfficeSubmit } from "./components/FindOfficeForm/findOfficeSubmit.js";
import { initAgentLogin } from "./components/AgentLogin/initAgentLogin.jsx";
import { initOrderServicesForm } from "./components/Forms/initOrderServicesForm.jsx";
import { initAzureB2CUploadCsvForm } from "./components/AzureB2CUploadCsvForm/initAzureB2CUploadCsvForm.jsx";
import { initCPLForm } from "./components/Forms/initCPLForm.jsx";
import { initSitecoreFormUploadProgress } from "./components/SitecoreFormUpload/initSitecoreFormUploadProgress.jsx";
import { initFileUploadAuthGate } from "./components/SitecoreFormUpload/initFileUploadAuthGate.jsx";
import { initFileUploadSelection } from "./components/SitecoreFormUpload/initFileUploadSelection.js";
import { initSSORequestAccountForm } from "./components/SSORequestAccountForm/initSSORequestAccountForm.jsx";
import initGatedContent from "./components/GatedContent/initGatedContent.js";
import { initSSOAccountApproval } from "./components/SSOAccountApproval/initSSOAccountApproval.jsx";
import { initSSOAccountSearch } from "./components/SSOAccountSearch/initSSOAccountSearch.jsx";
import { initSSOBulkUpload } from "./components/SSOBulkUpload/initSSOBulkUpload.jsx";
import { initAIBot } from "./components/AIBot/initAIBot.jsx";
import { initAPIKeyManager } from "./components/APIKeyManager/initAPIKeyManager.jsx";
import { initVUApiHistory } from "./components/VUApiHistory/initVUApiHistory.jsx";
import init404Redirect from "./components/NotFoundRedirect/init404Redirect.js";


// This is required to make Storybook run JS when patterns are choosen
document.addEventListener("DOMContentLoaded", () => {
  document.querySelectorAll(".js-rich-text").forEach(richText);

  [...document.querySelectorAll(".js-make-clickable")].forEach(makeClickable);
  const isPdfHref = (href) => /\.pdf([?#]|$)/i.test(href);

  const ensurePdfNewTab = (link) => {
    if (!link.target || link.target === "_self") link.target = "_blank";
    if (!link.rel || !link.rel.includes("noopener")) link.rel = "noopener noreferrer";
  };

  document.querySelectorAll('a[href]').forEach((link) => {
    if (isPdfHref(link.getAttribute('href'))) ensurePdfNewTab(link);
  });

  document.addEventListener("click", (e) => {
    const link = e.target.closest("a[href]");
    if (link && isPdfHref(link.getAttribute('href'))) ensurePdfNewTab(link);
  });

  new MutationObserver((mutations) => {
    for (const mutation of mutations) {
      for (const node of mutation.addedNodes) {
        if (node.nodeType !== Node.ELEMENT_NODE) continue;
        const links = node.tagName === "A" ? [node] : node.querySelectorAll ? [...node.querySelectorAll('a[href]')] : [];
        links.forEach((link) => { if (isPdfHref(link.getAttribute('href'))) ensurePdfNewTab(link); });
      }
    }
  }).observe(document.body, { childList: true, subtree: true });

  // JS apps
  recentlyViewedTracking(); //tracking of recently viewed pages
  initRecentlyViewed(); //list of tracked recently viewed pages
  initRecentlyViewedMobile();
  initGlobalHeader();
  initSkipNavigation();
  initBackToTop();
  renderYouTubeVideo();
  initContentList();
  initListItem();
  initAlertBanner();
  initTermsOfUse();
  initAccordion();
  initTabs();
  initTableOfContents();
  initTopicList();
  initSelectDropdown();
  initModal();
  initBreadcrumb();
  initUtilityNav();
  initSearchBox();
  initDownload();
  readingPane();
  initMailToForm();
  // const mapstest = new LocatorResultsOfficeSearchHandler();
  // mapstest.decorate(document.querySelector('.js-maps-test'));
  // not running form validation until confirming  sitecore does client side validation
  //  initFormValidation();
  initMobileLanguageDropdown();

  renderFindOffice();
  renderAgencyVerifications();
  initAutocomplete();
  initFindOfficeViewToggle();
  initFindOfficePager();
  initFindOfficeSubmit();
  initRegistrationForm();
  initMemberProfileForm();
  initAgentLogin();
  initOrderServicesForm();
  initAzureB2CUploadCsvForm();
  initMarketoForms();
  initAEMScriptBridge();
  initSSORequestAccountForm();
  initCPLForm();
  initSitecoreFormUploadProgress();
  initFileUploadAuthGate();
  initFileUploadSelection();
  initSSOAccountApproval();
  initSSOAccountSearch();
  initSSOBulkUpload();
  initAIBot();
  initAPIKeyManager();
  initVUApiHistory();
  init404Redirect();

  // LanguageSelector
  // Fix language selector hrefs to preserve current page path on language switch
  const currentPath = window.location.pathname;
  const pathWithoutLang = currentPath.replace(/^\/[a-z]{2}(\/|$)/, "/");
  const langSuffix = pathWithoutLang + window.location.search;

  document.querySelectorAll(".js-lang-select-menu-link").forEach((link) => {
    const href = (link.getAttribute("href") || "").trim();
    if (/^\/[a-z]{2}\/?$/.test(href)) {
      link.setAttribute("href", href.replace(/\/$/, "") + langSuffix);
    }
    else if (href === "/" || href === "") {
      link.setAttribute("href", "/en" + langSuffix);
    }
  });

  document.querySelectorAll(".js-lang-select-nav").forEach(languageSelector);

  // VU Authenticated Utility Nav Menu
  document.querySelectorAll(".js-vu-auth-menu").forEach(VUAuthenticatedMenu);

  // Expandable Listings
  const viewAllables = $.makeArray($(".js-view-all-expand")).map(el => {
    return new ViewAllExpand($(el));
  });

  document.querySelector(".gated-content__panel") && initGatedContent();

  // Slideshows
  document.querySelectorAll(".js-slideshow-slider").forEach(initSlideShow);

  // Logo / underwriter carousels
  // document.querySelectorAll(".js-logo-carousel").forEach(initLogoCarousel);
  // Hero Slideshow (slick-based hero carousel)
  document.querySelectorAll(".js-hero-slideshow").forEach(initHeroSlideshow);

  // Dynamic Banners (Hero and Page Banner)
  const $banners = $(".js-dynamic-banner");
  if ($banners.length) {
    const dynamicBanners = $.makeArray($banners).map(el => {
      return new DynamicBanner($(el));
    });
  }

  // Pause Video button
  document
    .querySelectorAll(".js-background-video")
    .forEach(initBackgroundVideo);

  // Keyboard a11y for nav popouts
  document.querySelectorAll(".js-nav-popout").forEach(wrapper => {
    const popout_elm = wrapper.querySelector(".subnav-list");
    const toggle_button = wrapper.querySelector(".js-nav-toggle");
    let openedAt = 0;
    const togglePopout = () => {
      if (popout_elm) {
        popout_elm.classList.toggle("subnav-list--open");
        const isOpen = popout_elm.classList.contains("subnav-list--open");
        toggle_button.setAttribute("aria-expanded", isOpen);
        if (isOpen) {
          openedAt = Date.now();
          const firstLink = popout_elm.querySelector(".subnav-list__link");
          if (firstLink) setTimeout(() => firstLink.focus(), 50);
        }
      }
    };
    toggle_button.addEventListener("click", e => {
      e.preventDefault();
      togglePopout();
    });
    // Listen inside the entire wrapper for Escape key to close the popout
    wrapper.addEventListener("keydown", e => {
      if (e.code === "Escape" || e.key === "Escape") {
        e.preventDefault();
        if (popout_elm && popout_elm.classList.contains("subnav-list--open")) {
          popout_elm.classList.remove("subnav-list--open");
          toggle_button.setAttribute("aria-expanded", "false");
          toggle_button.focus();
        }
      }
    });
    // Automatically close a popout when focus moves outside of it
    wrapper.addEventListener("focusout", e => {
      if (Date.now() - openedAt < 300) return;
      if (popout_elm && !wrapper.contains(e.relatedTarget)) {
        popout_elm.classList.remove("subnav-list--open");
        toggle_button.setAttribute("aria-expanded", "false");
      }
    });
  });

  // react Apps
  renderDynamicContentListing();
  renderPromoListing();
  renderSearch();
  renderCalculators();

  if ($(".js-profile").length) {
    const previewControl = new ProfileControl(
      document.querySelector(".js-profile"),
    );
  }

  //handle interest group select all
  if ($(".js-interests-form").length) {
    const intersetsGroups = new InterestsGroups(
      document.querySelector(".js-interests-form"),
    );
  }

  [...document.querySelectorAll(".js-show-password")].forEach(el => {
    const dynamicPassword = new DynamicPassword($(el));
  });

  if ($(".js-form").length) {
    Forms(document, window);
  }

  if ($(".js-privacy-banner").length) {
    new PrivacyModal($(".js-privacy-banner"));
  }
});

window.addEventListener("load", () => {
  // Retry AIBot initialization on window load (fallback for late-loading content)
  const existingBot = document.querySelector(".js-ai-bot-mount df-messenger");
  if (!existingBot) {
    initAIBot();
  }
});
